/**
 * AnimatedNumber — vertical roll animation when value changes
 */

import { AnimatePresence, motion } from 'framer-motion';
import { springs } from '../../animation';
import { useReducedMotion } from '../../hooks/useReducedMotion';

interface AnimatedNumberProps {
  value: number | string;
  className?: string;
}

export default function AnimatedNumber({ value, className = '' }: AnimatedNumberProps) {
  const reduced = useReducedMotion();

  if (reduced) {
    return <span className={className}>{value}</span>;
  }

  return (
    <span className={`inline-flex overflow-hidden ${className}`}>
      <AnimatePresence mode="popLayout" initial={false}>
        <motion.span
          key={value}
          initial={{ y: '100%', scale: 0.8, opacity: 0 }}
          animate={{ y: 0, scale: 1, opacity: 1 }}
          exit={{ y: '-100%', scale: 0.8, opacity: 0 }}
          transition={springs.snappy}
        >
          {value}
        </motion.span>
      </AnimatePresence>
    </span>
  );
}
